import type { ReactNode } from 'react'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import styles from './ConversationView.module.css'
import { useElementSize } from '@/hooks/element-hooks'

export interface ConversationViewProps {
  header?: ReactNode
  banner?: ReactNode
  renderMessages: (small: boolean) => ReactNode
  composer?: ReactNode
}

export function ConversationView({
  header,
  banner,
  renderMessages,
  composer,
}: ConversationViewProps) {
  const { size, connectRef } = useElementSize()
  const small = size.width !== 0 && size.width < 800

  return (
    <Sandwich stretch className={styles.root}>
      <SandwichBun>
        {header}
        {banner}
      </SandwichBun>
      <SandwichContent ref={connectRef}>
        {renderMessages(small)}
      </SandwichContent>
      {composer && <SandwichBun>{composer}</SandwichBun>}
    </Sandwich>
  )
}
